import { DEFAULT_ROWS_PER_PAGE } from "../../../config-global";
import { useEffect, useState } from "react";
import axios from "../../../lib/axios";
import {
  PRODUCT_DELETE,
  PRODUCT_FIND_MANY,
} from "../../../lib/endpoints/product";
import { BrandModel } from "../../../models/brand";
import { MerChantModel } from "../../../models/merChantModel";
import { useRef } from "react";
import { MainGroupModel } from "../../../models/mainGroup";
import { DivisionModel } from "../../../models/division";
import { CategoryModel } from "../../../models/category";
import { SubCategoryModel } from "../../../models/subCategory";
import { ProductMerchantModel } from "../../../models/productMerchant";
import { concatenateStrings } from "../../../utils/concatenateStrings";
import { ProductBadgeEnum } from "../../../enums/productBadge";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import { MerchantUserModel } from "../../../models/merchantUser";
import {
  getCountProductMerchant,
  getProductMerchant,
  handleGetProductMerchantByCategory,
  handleSearchProductMerchant,
} from "../../../service/productMerchant";
import { getMainGroupByMerchantId } from "../../../service/mainGroup";
import { getDivisionByMerchantId } from "../../../service/division";
import { getCategoriesByMerchantId } from "../../../service/categories";
import { getSubCategoriesByMerchantId } from "../../../service/subCategory";
import { getAllBandProduct } from "../../../service/bandProduct";

export const useProductMerchantController = () => {
  const merchantData: MerchantUserModel =
    useSelector((state: RootState) => state?.auth?.data) || null!;

  const [loading, setLoading] = useState<boolean>(true);
  const [loadingFetchDataMore, setLoadingFetchDataMore] =
    useState<boolean>(false);
  const [loadingDataTable, setLoadingDataTable] = useState<boolean>(true);

  const [data, setData] = useState<ProductMerchantModel[]>([]);

  const [dataBrand, setDataBrand] = useState<BrandModel[]>([]);
  const [dataMerchants, setDataMerchants] = useState<MerChantModel[]>([]);

  const [dataMainGroup, setDataMainGroup] = useState<MainGroupModel[]>([]);
  const [dataDivisions, setDataDivisions] = useState<DivisionModel[]>([]);
  const [dataCategories, setDataCategories] = useState<CategoryModel[]>([]);
  const [dataSubCategories, setDataSubCategories] = useState<
    SubCategoryModel[]
  >([]);

  const [dataMainGroupForSelect, setDataMainGroupForSelect] = useState<
    MainGroupModel[]
  >([]);
  const [dataDivisionForSelect, setDataDivisionForSelect] = useState<
    DivisionModel[]
  >([]);
  const [dataCategoryForSelect, setDataCategoryForSelect] = useState<
    CategoryModel[]
  >([]);
  const [dataSubCategoryForSelect, setDataSubCategoryForSelect] = useState<
    SubCategoryModel[]
  >([]);

  const [mainGroupValue, setMainGroupValue] = useState<string>("All");
  const [divisionValue, setDivisionValue] = useState<string>("All");
  const [categoryValue, setCategoryValue] = useState<string>("All");
  const [subCategoriesValue, setSubCategoriesValue] = useState<string>("All");

  const [productStatusType, setProductStatusType] = useState<ProductBadgeEnum>(
    ProductBadgeEnum.AllProduct
  );

  const [selectedData, setSelectedData] = useState<ProductMerchantModel>(null!);
  const [countAllProduct, setCountAllProduct] = useState<number>(0);

  const [selectedCheckboxId, setSelectedCheckboxId] = useState<string[]>([]);
  const [selectedId, setSelectedId] = useState<string>(null!);

  const [searchValue, setSearchValue] = useState<string>("");
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [openMenu, setOpenMenu] = useState(null);
  const [openForm, setOpenForm] = useState<boolean>(false);

  const [openDeleteDialog, setOpenDeleteDialog] = useState<boolean>(false);
  const [loadingDelete, setLoadingDelete] = useState<boolean>(false);
  const [isFormUpdateData, setIsFormUpdateData] = useState<boolean>(false);

  const searchRef = useRef<HTMLInputElement>(null!);

  // ------------ Get Data -------------- //

  const handleGetData = async () => {
    try {
      setLoadingDataTable(true);
      const resGetCountAllProduct = await getCountProductMerchant({
        merchantId: merchantData?.merchantId,
      });
      const resProduct = await getProductMerchant({
        merchantId: merchantData?.merchantId,
        take: 30,
      });
      const resMainGroup = await getMainGroupByMerchantId({
        merchantId: merchantData?.merchantId,
      });
      const resDivision = await getDivisionByMerchantId({
        merchantId: merchantData?.merchantId,
      });
      const resCategories: any = await getCategoriesByMerchantId({
        merchantId: merchantData?.merchantId,
      });
      const resSubCategories: any = await getSubCategoriesByMerchantId({
        merchantId: merchantData?.merchantId,
      });

      setData(resProduct);
      setCountAllProduct(resGetCountAllProduct);
      setDataMainGroup(resMainGroup);
      setDataDivisions(resDivision);
      setDataCategories(resCategories);
      setDataSubCategories(resSubCategories);

      setDataMainGroupForSelect(resMainGroup);

      const resGetDataBrand = await getAllBandProduct();

      setDataBrand(resGetDataBrand);
    } catch (err) {
      console.log("err=", err);
    } finally {
      setLoading(false);
      setLoadingDataTable(false);
    }
  };

  const handleFetchDataMore = async () => {
    try {
      setLoadingFetchDataMore(true);
      const params: any = {
        take: 30,
        skip: data?.length,
        productMainGroupId: mainGroupValue !== "All" ? mainGroupValue : "",
        productDivisionNameId: divisionValue !== "All" ? divisionValue : "",
        productCategoryId: categoryValue !== "All" ? categoryValue : "",
        productSubCategoryId:
          subCategoriesValue !== "All" ? subCategoriesValue : "",
        merchantId: merchantData?.merchantId,
      };
      if (productStatusType === ProductBadgeEnum.RecommendProduct) {
        params.recommend = true;
      }
      if (productStatusType === ProductBadgeEnum.NewProduct) {
        params.productNew = true;
      }
      const resPro = await getProductMerchant(params);
      const newData = [...data, ...resPro];
      setData(newData);
    } catch (err) {
    } finally {
      setLoadingFetchDataMore(false);
    }
  };

  const handleGetProductByStatusNewProductAndRecommend = async (
    status: ProductBadgeEnum
  ): Promise<void> => {
    try {
      setLoadingDataTable(true);
      let filtter = {};
      if (status === ProductBadgeEnum.NewProduct) {
        filtter = {
          productNew: true,
          recommend: false,
          merchantId: merchantData?.merchantId,
        };
        setCurrentPage(1);
      } else if (status === ProductBadgeEnum.RecommendProduct) {
        filtter = {
          recommend: true,
          productNew: false,
          merchantId: merchantData?.merchantId,
        };
        setCurrentPage(1);
      } else if (status === ProductBadgeEnum.PromotionProduct) {
        filtter = {
          merchantId: merchantData?.merchantId,
        };
        setCurrentPage(1);
      } else if (status === ProductBadgeEnum.AllProduct) {
        filtter = {};
        handleGetData();
        setCurrentPage(1);
      }

      const { data: resData } = await axios.post(PRODUCT_FIND_MANY, {
        filtter,
      });

      setData(resData);
    } catch (err) {
      console.error("Error fetching products:", err);
    } finally {
      setLoadingDataTable(false);
    }
  };

  // ------------ Get Data -------------- //

  const onChangePage = (event: any, newPage: any) => {
    setCurrentPage(newPage);
  };

  const handleSelectedStatusProduct = (newValue: ProductBadgeEnum) => {
    setProductStatusType(newValue);
    setCurrentPage(1);
    handleGetProductByStatusNewProductAndRecommend(newValue);
  };

  const onOpenForm = () => {
    setOpenMenu(null);
    setOpenForm(true);
  };

  const onCloseForm = () => {
    setOpenForm(false);
    setIsFormUpdateData(false);
  };

  const onOpenMenu = (event: any, getId: string) => {
    setOpenMenu(event.currentTarget);
    setSelectedId(getId);
    setSelectedData(data?.filter((item) => item?.id === getId)[0]);
  };

  const onDeleteData = () => {
    setData(data?.filter((item) => item?.id !== selectedId));
    setOpenMenu(null!);
  };

  const onDeleteSelectedData = () => {
    let newData = data;
    for (let i = 0; i < selectedCheckboxId.length; i++) {
      newData = newData?.filter((item) => item?.id !== selectedCheckboxId[i]);
    }

    setData(newData);
    setSelectedCheckboxId([]);
  };

  const onSearch = (e: any) => {
    setCurrentPage(1);
    setSearchValue(e.target.value);
  };

  const onSelectCheckBox = (event: any, getId: string) => {
    const selectedIndex = selectedCheckboxId.indexOf(getId);
    let newSelected: any = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selectedCheckboxId, getId);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selectedCheckboxId.slice(1));
    } else if (selectedIndex === selectedCheckboxId.length - 1) {
      newSelected = newSelected.concat(selectedCheckboxId.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selectedCheckboxId.slice(0, selectedIndex),
        selectedCheckboxId.slice(selectedIndex + 1)
      );
    }
    setSelectedCheckboxId(newSelected);
  };

  const onSelectCheckBoxAll = (event: any) => {
    if (event.target.checked) {
      const newSelecteds: any = filterData.map((n) => n.id);
      setSelectedCheckboxId(newSelecteds);
      return;
    }
    setSelectedCheckboxId([]);
  };

  const onCloseMenu = () => {
    setOpenMenu(null);
  };

  const handleSearch = (e: any) => {
    setSearchValue(e.target.value);
    setCurrentPage(1);
  };

  const handleGetProductByMainGroupCategory = async (
    mainId: string,
    divisionId: string,
    categoryId: string,
    subCategoryId: string
  ): Promise<void> => {
    try {
      setLoadingDataTable(true);

      const filter = {
        mainId,
        divisionId,
        categoryId,
        subCategoryId,
        merchantId: merchantData?.merchantId,
        take: 30,
      };

      const resData = await handleGetProductMerchantByCategory(filter);

      setData(resData);
    } catch (err) {
      console.error("Error fetching products:", err);
    } finally {
      setLoadingDataTable(false);
    }
  };

  const handleSearchProduct = async () => {
    try {
      setLoadingDataTable(true);
      if (searchValue) {
        setCurrentPage(1);
        const newData = await handleSearchProductMerchant(
          searchValue,
          merchantData?.merchantId
        );
        setData(newData);
      } else {
        await handleGetData();
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingDataTable(false);
    }
  };

  const handleMainGroupChange = async (e: any) => {
    const newValue = e.target.value;
    setMainGroupValue(newValue);
    setCurrentPage(1);
    if (newValue === "All") {
      setDataDivisionForSelect([]);
    } else {
      setDataDivisionForSelect(
        dataDivisions.filter((item) => item?.main_group_name_id === newValue)
      );
    }

    setDataCategoryForSelect([]);
    setDataSubCategoryForSelect([]);
    setDivisionValue("All");
    setCategoryValue("All");
    setSubCategoriesValue("All");

    // Fetch data based on mainId and default (or 'All') values for other IDs
    await handleGetProductByMainGroupCategory(newValue, "All", "All", "All");
  };

  const handleDivisionChange = async (e: any) => {
    const newValue = e.target.value;
    setDivisionValue(newValue);
    setCurrentPage(1);
    if (newValue === "All") {
      setDataCategoryForSelect([]);
    } else {
      setDataCategoryForSelect(
        dataCategories.filter((item) => item?.division_name_id === newValue)
      );
    }
    setDataSubCategoryForSelect([]);
    setCategoryValue("All");
    setSubCategoriesValue("All");

    // Fetch data based on mainId and default (or 'All') values for other IDs
    await handleGetProductByMainGroupCategory(
      mainGroupValue,
      newValue,
      "All",
      "All"
    );
  };

  const handleCategoryChange = async (e: any) => {
    const newValue = e.target.value;
    setCategoryValue(newValue);
    setCurrentPage(1);
    if (newValue === "All") {
      setDataSubCategoryForSelect([]);
    } else {
      setDataSubCategoryForSelect(
        dataSubCategories.filter(
          (item) => item?.product_category_id === newValue
        )
      );
    }
    setSubCategoriesValue("All");

    // Fetch data based on mainId and default (or 'All') values for other IDs
    await handleGetProductByMainGroupCategory(
      mainGroupValue,
      divisionValue,
      newValue,
      "All"
    );
  };

  const handleSubCategoryChange = async (e: any) => {
    const newValue = e.target.value;
    setSubCategoriesValue(newValue);
    setCurrentPage(1);
    // Fetch data based on selected values
    await handleGetProductByMainGroupCategory(
      mainGroupValue,
      divisionValue,
      categoryValue,
      newValue
    );
  };

  const handleOpenForm = () => {
    setOpenForm(true);
    setSelectedData(null!);
  };

  const handleClickEditButton = () => {
    setOpenForm(true);
    setOpenMenu(null!);
    setSelectedData(data?.filter((item) => item?.id === selectedId)[0]);
    setIsFormUpdateData(true);
  };

  const handleClickAddButton = () => {
    setOpenForm(true);
    setSelectedData(null!);
    setIsFormUpdateData(false);
  };

  const handlePageChange = (event: any, newPage: any) => {
    if (newPage === countPagination) {
      if (!loadingFetchDataMore) {
        handleFetchDataMore();
      }
    }
    setCurrentPage(newPage);
  };

  const handleFilterDataByItemCode = async () => {
    try {
      setLoading(true);
      const res = await axios.post(PRODUCT_FIND_MANY, {
        filtter: {
          itemcode: searchRef.current.value,
        },
      });
      if (res?.data?.length > 0) {
        setData(res?.data[0]);
      } else {
        setData([]);
      }
    } catch (err) {
      console.log("error=", err);
      window.alert("Server error please try again");
    } finally {
      setLoading(false);
    }
  };

  const handleClickDeleteButton = () => {
    setOpenMenu(null);
    setOpenDeleteDialog(true);
  };

  const handleDeleteAllProductByMerchant = () => {
    data?.map(async (subItem) => {
      try {
        const res = await axios.delete(`${PRODUCT_DELETE}?id=${subItem?.id}`);
        setData(data?.filter((item) => item?.id !== subItem?.id));
      } catch (err) {
        console.log("err=", err);
      }
    });
  };

  const handleDeleteData = async () => {
    try {
      setLoadingDelete(true);
      await axios.delete(`${PRODUCT_DELETE}?id=${selectedId}`);
      setData(data?.filter((item) => item?.id !== selectedId));
      setOpenDeleteDialog(false);
    } catch (err: any) {
      try {
        window.alert(err.response.data.message);
      } catch (err2) {
        window.alert("Server error please try again");
      }
    } finally {
      setLoadingDelete(false);
    }
  };

  const handleCloseDeleteDialog = () => {
    setOpenDeleteDialog(false);
  };

  const filterProductStatus: ProductMerchantModel[] = data?.filter(
    (item: ProductMerchantModel) => {
      if (productStatusType === ProductBadgeEnum.AllProduct) {
        return true;
      } else if (productStatusType === ProductBadgeEnum.NewProduct) {
        return item?.productNew === true;
      } else if (productStatusType === ProductBadgeEnum.RecommendProduct) {
        return item?.recommend === true;
      } else if (productStatusType === ProductBadgeEnum.PromotionProduct) {
        return item?.promotion?.promotionType ? true : false;
      }
      return false;
    }
  );

  const filterDataByCategory = filterProductStatus.filter((item) => {
    if (
      mainGroupValue === "All" &&
      divisionValue === "All" &&
      categoryValue === "All" &&
      subCategoriesValue === "All"
    ) {
      return true;
    } else if (
      mainGroupValue !== "All" &&
      divisionValue === "All" &&
      categoryValue === "All" &&
      subCategoriesValue === "All"
    ) {
      return item?.productMainGroupId === mainGroupValue;
    } else if (
      mainGroupValue !== "All" &&
      divisionValue !== "All" &&
      categoryValue === "All" &&
      subCategoriesValue === "All"
    ) {
      return (
        item?.productMainGroupId === mainGroupValue &&
        item?.productDivisionNameId === divisionValue
      );
    } else if (
      mainGroupValue !== "All" &&
      divisionValue !== "All" &&
      categoryValue !== "All" &&
      subCategoriesValue === "All"
    ) {
      return (
        item?.productMainGroupId === mainGroupValue &&
        item?.productDivisionNameId === divisionValue &&
        item?.productCategoryId === categoryValue
      );
    } else if (
      mainGroupValue !== "All" &&
      divisionValue !== "All" &&
      categoryValue !== "All" &&
      subCategoriesValue !== "All"
    ) {
      return (
        item?.productMainGroupId === mainGroupValue &&
        item?.productDivisionNameId === divisionValue &&
        item?.productCategoryId === categoryValue &&
        item?.productSubCategoryId === subCategoriesValue
      );
    } else {
      return false;
    }
  });

  const filterData = filterDataByCategory

  const rows = filterData.slice(
    (currentPage - 1) * DEFAULT_ROWS_PER_PAGE,
    currentPage * DEFAULT_ROWS_PER_PAGE
  );
  // const rows=data;
  const countPagination = Math.ceil(filterData.length / DEFAULT_ROWS_PER_PAGE);

  const isSearchNotFound: boolean = !filterData.length && !!searchValue;

  // useEffect
  useEffect(() => {
    handleGetData();
  }, []);

  return {
    selectedCheckboxId,
    onDeleteData,
    searchValue,
    onSearch,
    filterData,
    onSelectCheckBoxAll,
    rows,
    openMenu,
    onCloseMenu,
    onOpenMenu,
    onOpenForm,
    onCloseForm,
    openForm,
    onChangePage,
    currentPage,
    isSearchNotFound,
    onSelectCheckBox,
    onDeleteSelectedData,
    countPagination,
    loading,
    handlePageChange,
    loadingFetchDataMore,
    selectedData,
    countAllProduct,
    dataBrand,
    dataMainGroup,
    dataDivisions,
    dataCategories,
    dataSubCategories,
    handleGetData,
    dataMerchants,
    handleFilterDataByItemCode,
    searchRef,
    handleOpenForm,
    openDeleteDialog,
    loadingDelete,
    handleCloseDeleteDialog,
    handleDeleteData,
    handleClickDeleteButton,
    handleClickEditButton,
    isFormUpdateData,
    handleClickAddButton,
    handleDeleteAllProductByMerchant,
    setSearchValue,
    handleSelectedStatusProduct,
    productStatusType,
    // dataStock,
    mainGroupValue,
    divisionValue,
    categoryValue,
    subCategoriesValue,
    handleChangeMainGroup: (newValue: string) => setMainGroupValue(newValue),
    handleChangeDivision: (newValue: string) => setDivisionValue(newValue),
    handleChangeCategories: (newValue: string) => setCategoryValue(newValue),
    handleChangeSubCategory: (newValue: string) =>
      setSubCategoriesValue(newValue),
    handleMainGroupChange,
    handleDivisionChange,
    handleCategoryChange,
    handleSubCategoryChange,
    dataMainGroupForSelect,
    dataDivisionForSelect,
    dataCategoryForSelect,
    dataSubCategoryForSelect,
    merchantId: merchantData?.merchantId,
    handleSearch,
    loadingDataTable,
    handleSearchProduct,
  };
};
